import { render, staticRenderFns } from "./StandardList.vue?vue&type=template&id=8ab2bc4e&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./StandardList.vue?vue&type=script&lang=js&"
export * from "./StandardList.vue?vue&type=script&lang=js&"
import style0 from "./StandardList.vue?vue&type=style&index=0&id=8ab2bc4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab2bc4e",
  null
  
)

export default component.exports